import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expand\">\n<g clip-path=\"url(#expand_clip0_2147_14085)\">\n<path d=\"M3.41 12L8 7.42L12.59 12L14 10.59L8 4.59L2 10.59L3.41 12Z\" />\n</g>\n<defs>\n<clipPath id=\"expand_clip0_2147_14085\">\n<rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(16 16) rotate(-180)\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol